export default __webpack_public_path__ + "static/img_2_1-d650fee1e886fce9ec96a9592a3f1e05.jpg";